import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SyncProvider } from "@/context/SyncContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { DesktopSidebar } from "@/components/DesktopSidebar";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ActivateAccount from "@/pages/ActivateAccount";
import WorkerHome from "@/pages/WorkerHome";
import ServicePicker from "@/pages/ServicePicker";
import RegisterView from "@/pages/RegisterView";
import ArchiveView from "@/pages/ArchiveView";
import LeaveRequests from "@/pages/LeaveRequests";
import IndirectHours from "@/pages/IndirectHours";
import AgendaView from "@/pages/AgendaView";
import OfficeHome from "@/pages/OfficeHome";
import OfficeWorkerFolder from "@/pages/OfficeWorkerFolder";
import AdminHome from "@/pages/AdminHome";
import CoverPreview from "@/pages/CoverPreview";
import IntroPreview from "@/pages/IntroPreview";
import { TrainingBadge } from "@/components/TrainingBadge";
import { DevViewportToggle } from "@/components/DevViewportToggle";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SyncProvider>
          <TrainingBadge />
          <BrowserRouter>
            <DesktopSidebar />
            <ErrorBoundary>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/password-dimenticata" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/activate-account" element={<ActivateAccount />} />
              <Route path="/lavoratore" element={<ProtectedRoute role="LAVORATORE"><WorkerHome /></ProtectedRoute>} />
              <Route path="/archivio" element={<ProtectedRoute role="LAVORATORE"><ArchiveView /></ProtectedRoute>} />
              <Route path="/assenze" element={<ProtectedRoute role="LAVORATORE"><LeaveRequests /></ProtectedRoute>} />
              <Route path="/ore-indirette" element={<ProtectedRoute role="LAVORATORE"><IndirectHours /></ProtectedRoute>} />
              <Route path="/agenda" element={<ProtectedRoute role="LAVORATORE"><AgendaView /></ProtectedRoute>} />
              <Route path="/servizio/:slug" element={<ProtectedRoute role="LAVORATORE"><ServicePicker /></ProtectedRoute>} />
              <Route path="/registro/:slug/:entityId" element={<ProtectedRoute role="LAVORATORE"><RegisterView /></ProtectedRoute>} />
              <Route path="/ufficio" element={<ProtectedRoute role="UFFICIO"><OfficeHome /></ProtectedRoute>} />
              <Route path="/ufficio/lavoratore/:id" element={<ProtectedRoute role="UFFICIO"><OfficeWorkerFolder /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute role="AMMINISTRATORE"><AdminHome /></ProtectedRoute>} />
              <Route path="/preview-copertina" element={<CoverPreview />} />
              <Route path="/preview-intro" element={<IntroPreview />} />
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
            </ErrorBoundary>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
          {process.env.NODE_ENV === "development" && <DevViewportToggle />}
        </SyncProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
